<template>
    <hp5-page-content-container>
        <div id="csearch-main-container">
            <div class="top-panel">
                <ApplicationBreadCrumbs />
                <FilterNetworkPlanSwitcher class="right" />
            </div>
            <CriteriaBar />
            <AberrantNetworkAlert :showComponent="showComponent" :showApp="showApp" :isError="isError" :messages="messages"  />
            <ApplicationHorizontalRule />
            <ApplicationPromotedServices />
            <ApplicationFiltersAndResults />
        </div>
    </hp5-page-content-container>
</template>

<script setup>
const { profile } = useFCPModel()
let { showApp, showComponent, isError, messages } = useProfileInfo(profile.value)

</script>

<style lang="scss" scoped>

.top-panel {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 1rem;
}

.right {
    margin-bottom: 21px;
}
</style>
